import React, { useEffect, useState } from "react";
import apiInstance from "../../../utils/axios";

interface BannerData {
  id: number;
  title: string;
  image: string;
  link: string | null;
  is_active: boolean;
}

const Banner2Dual: React.FC = () => {
  const [banners, setBanners] = useState<BannerData[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await apiInstance.get('banners2/');
        const bannersData = Array.isArray(response.data) 
          ? response.data 
          : (response.data.results || []);
        // Get first 2 active banners
        const activeBanners = bannersData.filter((b: BannerData) => b.is_active).slice(0, 2);
        setBanners(activeBanners);
      } catch (error) {
        console.error('Error fetching banners2:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchBanners();
  }, []);

  const handleBannerClick = (link: string | null) => {
    if (link) {
      window.location.href = link;
    }
  };

  if (loading) {
    return (
      <div className="mx-auto max-w-7xl px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="h-48 md:h-64 bg-secondary rounded-xl animate-pulse" />
          <div className="h-48 md:h-64 bg-secondary rounded-xl animate-pulse" />
        </div>
      </div>
    );
  }

  if (banners.length === 0) {
    return null;
  }

  // Single banner - full width
  if (banners.length === 1) {
    const banner = banners[0];
    return (
      <div className="mx-auto max-w-7xl px-4">
        <div
          onClick={() => handleBannerClick(banner.link)}
          className={`relative overflow-hidden rounded-xl shadow-lg transition-transform duration-300 hover:shadow-xl ${banner.link ? 'cursor-pointer hover:scale-[1.01]' : ''}`}
        >
          <img
            src={banner.image}
            alt={banner.title || 'Banner'}
            className="w-full h-auto object-cover"
            style={{ maxHeight: '350px', minHeight: '200px' }}
          />
        </div>
      </div>
    );
  }

  // Two banners - side by side
  return (
    <div className="mx-auto max-w-7xl px-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {banners.map((banner) => (
          <div
            key={banner.id}
            onClick={() => handleBannerClick(banner.link)}
            className={`relative overflow-hidden rounded-xl shadow-lg transition-transform duration-300 hover:shadow-xl ${banner.link ? 'cursor-pointer hover:scale-[1.02]' : ''}`}
          >
            <img
              src={banner.image}
              alt={banner.title || 'Banner'}
              className="w-full h-full object-cover"
              style={{ minHeight: '180px', maxHeight: '280px' }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Banner2Dual;
